import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { createChangeTasks, getChangeTasks, updateChangeTasks } from "../../api/changeTasks/changeTasksApi";
import { ChangeTasks, ChangeTask } from "../../api/changeTasks/types";


export const useChangeTasks = (divisionCode: string, eventType: string) => {
       return useQuery({
              queryKey: ['changeTasks'],
              queryFn: () => getChangeTasks({ filter: `divisionCode=${divisionCode},eventType=${eventType},completed=false` }),
              enabled: !!divisionCode && !!eventType,
              refetchInterval: 1000 * 60 * 1,
              refetchIntervalInBackground: true,
              refetchOnWindowFocus: true,
              refetchOnMount: true,
              refetchOnReconnect: true,
       });
};


export const useCreateChangeTasks = () => {
       const queryClient = useQueryClient();

       return useMutation({
              mutationFn: (changeTasks: Partial<ChangeTask>) => createChangeTasks(changeTasks as ChangeTask),
              onSuccess: (data) => {
                     queryClient.setQueryData(['changeTasks'], (oldData: ChangeTasks) => {
                            if (Array.isArray(oldData)) {
                                   return [...oldData, ...(Array.isArray(data) ? data : [data])];
                            }
                            return data;
                     });
                     queryClient.invalidateQueries({ queryKey: ['changeTasks'] });
              },
              onError: (error) => {
                     console.error(error);
              },
       });
};

export const useUpdateChangeTasks = () => {
       const queryClient = useQueryClient();

       return useMutation({
              mutationFn: (changeTasks: Partial<ChangeTask>) => updateChangeTasks(changeTasks as ChangeTask),
              onSuccess: (data) => {
                     queryClient.setQueryData(['changeTasks'], (oldData: ChangeTasks) => {
                            return oldData;
                     });
                     queryClient.invalidateQueries({ queryKey: ['changeTasks'] });
              },
              onError: (error) => {
                     console.error(error);
              },
       });
};


